module.exports = __webpack_public_path__ + "static/img/theme.4c5fecd7.jpg";